module.exports = __webpack_public_path__ + "img/login_bg_icon_v2.3b0ed2f8.png";